import { gql } from 'graphql-request';

export const GET_SHIPMENT_REGISTRY_SCHEME = gql`
  query App5182dd71_ShipmentRegistry($documentId: String!) {
    app5182dd71_ShipmentRegistry {
      getTemplate(documentId: $documentId) {
        template {
          step
          name
          type
          required
          disabled
          isSearchable
          placeholder
          fieldTransform
          fieldType
          isVisible
          isVisibleDependency
          stepLabel
          validation
          optionsDependency
          value
          label {
            ru
            en
          }
          options {
            label
            value
          }
          optionsDependentSelect {
            value
            options {
              label
              value
            }
          }
        }
      }
    }
  }
`;
